export const BILLING_ITEM_TYPES = {
  SUBSCRIPTION: "subscription",
  ONE_TIME: "one_time",
};

export const BILLING_ITEM_TYPE_OPTIONS = [
  {
    value: "subscription",
    label: "Abonnement annuel",
  },
  {
    value: "one_time",
    label: "Prestation ponctuelle",
  },
];

export const BILLING_ITEM_TYPE_LABELS = {
  subscription: "Abonnement annuel",
  one_time: "Prestation ponctuelle",
};

export const PERIODICITY_OPTIONS = [
  {
    value: "annuel",
    label: "Annuel",
  },
  {
    value: "ponctuel",
    label: "Ponctuel",
  },
];

/*
 * On garde le mensuel dans les labels pour les éventuelles
 * anciennes lignes, mais il ne sera plus proposé dans les formulaires.
 */
export const PERIODICITY_LABELS = {
  mensuel: "Mensuel",
  annuel: "Annuel",
  ponctuel: "Ponctuel",
};

export const RENEWAL_STATUS_OPTIONS = [
  {
    value: "not_started",
    label: "Non commencé",
  },
  {
    value: "to_prepare",
    label: "Devis à préparer",
  },
  {
    value: "quote_sent",
    label: "Devis envoyé",
  },
  {
    value: "accepted",
    label: "Accepté",
  },
  {
    value: "refused",
    label: "Refusé",
  },
  {
    value: "renewed",
    label: "Renouvelé",
  },
];

export const RENEWAL_STATUS_LABELS = {
  not_started: "Non commencé",
  to_prepare: "Devis à préparer",
  quote_sent: "Devis envoyé",
  accepted: "Accepté",
  refused: "Refusé",
  renewed: "Renouvelé",
  not_applicable: "Non applicable",
};

export const PAYMENT_STATUS_LABELS = {
  not_invoiced: "Non facturé",
  pending: "En attente",
  partial: "Paiement partiel",
  paid: "Payé",
  overdue: "En retard",
};

export const PAYMENT_STATUS_STYLES = {
  not_invoiced:
    "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300",

  pending:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900/60 dark:bg-amber-950/30 dark:text-amber-300",

  partial:
    "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900/60 dark:bg-sky-950/30 dark:text-sky-300",

  paid:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/60 dark:bg-emerald-950/30 dark:text-emerald-300",

  overdue:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300",
};

export const RENEWAL_STATUS_STYLES = {
  not_started:
    "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300",

  to_prepare:
    "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-900/60 dark:bg-orange-950/30 dark:text-orange-300",

  quote_sent:
    "border-violet-200 bg-violet-50 text-violet-700 dark:border-violet-900/60 dark:bg-violet-950/30 dark:text-violet-300",

  accepted:
    "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900/60 dark:bg-sky-950/30 dark:text-sky-300",

  refused:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300",

  renewed:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/60 dark:bg-emerald-950/30 dark:text-emerald-300",

  not_applicable:
    "border-slate-200 bg-slate-50 text-slate-500 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400",
};

export const DASHBOARD_PERIOD_OPTIONS = [
  {
    value: 6,
    label: "6 mois",
  },
  {
    value: 12,
    label: "12 mois",
  },
  {
    value: 24,
    label: "24 mois",
  },
];

export const DASHBOARD_METRIC_OPTIONS = [
  {
    value: "clients",
    label: "Nouveaux clients",
  },
  {
    value: "subscriptions",
    label: "Abonnements",
  },
  {
    value: "revenue",
    label: "Chiffre d’affaires",
  },
];

export const ACTION_CENTER_TABS = [
  {
    value: "renewals",
    label: "À renouveler",
  },
  {
    value: "quotes",
    label: "Devis à relancer",
  },
  {
    value: "overdue",
    label: "Paiements en retard",
  },
  {
    value: "expired",
    label: "Expirés",
  },
  {
    value: "missing",
    label: "Données manquantes",
  },
];

export const PRODUCT_OPTIONS = [
  "MonAppliClub Standard",
  "MonAppliClub Light",
  "MonAppliClub Omnisport",
  "Website",
  "Nom de Domaine",
  "MonAppliTournoi",
  "Judo Présence Pro",
  "Judo Coach Pro",
  "MonAppliMairie",
  "MonAppliComité",
  "MonAppliLigue",
  "MonAppliAsso",
  "Notifications Push",
  "Maintenance corrective",
  "Évolution de code",
  "Développement spécifique",
  "Accompagnement technique",
];

export const SUBSCRIPTION_STATUS_OPTIONS = [
  "Devis en attente de signature",
  "Abonné",
  "Période d'essai",
  "Expiré",
  "Résilié",
  "Terminé",
];

export const ONE_TIME_STATUS_OPTIONS = [
  "Devis en attente de signature",
  "Commande acceptée",
  "En cours",
  "Livrée",
  "Terminée",
  "Annulée",
];

export const RENEWAL_FORM_OPTIONS = [
  {
    value: "not_started",
    label: "Non commencé",
  },
  {
    value: "to_prepare",
    label: "Devis à préparer",
  },
  {
    value: "quote_sent",
    label: "Devis envoyé",
  },
  {
    value: "accepted",
    label: "Accepté",
  },
  {
    value: "refused",
    label: "Refusé",
  },
  {
    value: "renewed",
    label: "Renouvelé",
  },
];

export const PAYMENT_PREVIEW_LABELS = {
  not_invoiced: "Non facturé",
  pending: "En attente de paiement",
  partial: "Paiement partiel",
  paid: "Payé",
  overdue: "Paiement en retard",
};

export const PAYMENT_PREVIEW_STYLES = {
  not_invoiced:
    "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300",

  pending:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-300",

  partial:
    "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900 dark:bg-sky-950/30 dark:text-sky-300",

  paid:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900 dark:bg-emerald-950/30 dark:text-emerald-300",

  overdue:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-900 dark:bg-red-950/30 dark:text-red-300",
};